// Posistion: Sticky polyfill
(function () {
  var elements = document.querySelectorAll('.sticky-article .sticky-column');
  if (elements!==undefined && elements.length>0) {
    Stickyfill.add(elements);
  }
 
})();

(function ($) {

  var Defaults = $.fn.select2.amd.require('select2/defaults');

  $.extend(Defaults.defaults, {
    dropdownPosition: 'auto'
  });

  var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');

  var _positionDropdown = AttachBody.prototype._positionDropdown;

  AttachBody.prototype._positionDropdown = function () {

    var $window = $(window);

    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

    var newDirection = null;

    var offset = this.$container.offset();

    offset.bottom = offset.top + this.$container.outerHeight(false);

    var container = {
      height: this.$container.outerHeight(false)
    };

    container.top = offset.top;
    container.bottom = offset.top + container.height;

    var dropdown = {
      height: this.$dropdown.outerHeight(false)
    };

    var viewport = {
      top: $window.scrollTop(),
      bottom: $window.scrollTop() + $window.height()
    };

    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

    var css = {
      left: offset.left,
      top: container.bottom
    };

    // Determine what the parent element is to use for calciulating the offset
    var $offsetParent = this.$dropdownParent;

    // For statically positoned elements, we need to get the element
    // that is determining the offset
    if ($offsetParent.css('position') === 'static') {
      $offsetParent = $offsetParent.offsetParent();
    }

    var parentOffset = $offsetParent.offset();

    css.top -= parentOffset.top
    css.left -= parentOffset.left;

    var dropdownPositionOption = this.options.get('dropdownPosition');

    if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {

      newDirection = dropdownPositionOption;

    } else {

      if (!isCurrentlyAbove && !isCurrentlyBelow) {
        newDirection = 'below';
      }

      if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
        newDirection = 'above';
      } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
        newDirection = 'below';
      }

    }

    if (newDirection == 'above' ||
      (isCurrentlyAbove && newDirection !== 'below')) {
      css.top = container.top - parentOffset.top - dropdown.height;
    }

    if (newDirection != null) {
      this.$dropdown
        .removeClass('select2-dropdown--below select2-dropdown--above')
        .addClass('select2-dropdown--' + newDirection);
      this.$container
        .removeClass('select2-container--below select2-container--above')
        .addClass('select2-container--' + newDirection);
    }

    this.$dropdownContainer.css(css);

  };

})(window.jQuery);


// Header
(function () {


  var $body = $('body');
  var headroom = new Headroom($('.headroom')[0], {
    offset: 50,
    tolerance: {
      up: 30,
      down: 10
    },
    onPin: function () {
      $body.removeClass('headroom-page--pinned');
    },
    onUnpin: function () {
      $body.addClass('headroom-page--pinned');
    },
    onTop: function () {
      $body.removeClass('headroom-page--not-top');
    },
    // callback when unpinned, `this` is headroom object
    onNotTop: function () {
      $body.addClass('headroom-page--not-top');
    }
  });
  // initialise
  headroom.init();



  $line = $('.main-navigation .line');
  $nav = $('.main-navigation');
  $('.mega-window').each(function () {
    $(this).parent().addClass('has-mega-nav');
  });

  if ($('body').width() > 1150) {
    $('.main-navigation > ul > li > a').on('mouseover', function (e) {
      var text = $(this).find('span');
      $line.css({ 'left': text.offset().left, 'width': text.width() });
    }).on('mouseout', function (e) {

      // if ($('body').width()<1250) {
      $line.css({ 'left': 212, 'width': 'calc(100% - 212px)' });
      //} else {
      //    $line.css({'left':284, 'width':'calc(100% - 284px)'});
      //}



    });


    $('.main-navigation ul').superfish({
      hoverClass: 'open',
      animation: { height: 'show' },
      animationOut: { height: 'hide' },
      popUpSelector: '.mega-window',
      cssArrows: false,
      speed: '900',           // speed of the opening animation. Equivalent to second parameter of jQuery’s .animate() method
      speedOut: '700',
      onBeforeShow: function () {
        $('body').addClass('mega-open');
      },

      onBeforeHide: function () {
        $('body').removeClass('mega-open');
      },

    });
  } else {

    $('.main-navigation > ul > li.has-mega-nav').append('<button class="mobile-toggle" aria-label="View sub menu"><svg class="plus" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g transform="translate(18 91.642) rotate(180)"><g transform="translate(0 76.5)"><g transform="translate(-33.5)"><line y1="18" transform="translate(42.5 -2.859)" fill="none" stroke="#073B40" stroke-width="3"  class="line"></line><line x1="18" transform="translate(33.5 6.141)" fill="none" stroke="#073B40" stroke-width="3"></line></g></g></g></svg></button>')

    $('.main-navigation > ul > li > .mobile-toggle').on('click', function (e) {
      e.preventDefault();


      if ($(this).parent().hasClass('open')) {
        $('#menu-main-menu .open').each(function (i, el) {

          $(el).removeClass('open');
          $(el).find('.mega-nav').slideUp();
        });

      } else {
        $('#menu-main-menu .open').each(function (i, el) {

          $(el).removeClass('open');
          $(el).find('.mega-nav').slideUp();
        });
        $(this).parent().toggleClass('open');
        $(this).parent().find('.mega-nav').slideDown();

      }
    });

  }






  // Search
  $('.search-btn').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('search-open');
    setTimeout(function () {
      $('header .form-text.ep-autosuggest-input').focus();

    }, 250);

  });

  $('header .form-text.ep-autosuggest-input').on('blur', function (e) {
    setTimeout(function () {

      $('body').removeClass('search-open');
    }, 100);

  });


  //Mega Nav


  $('a[target="_blank"]').append('<span class="visuallyhidden"> Opens in a new window</span>');




  $('.button-mobile').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-active');

    $('body').toggleClass('menu-open');

    $('body').removeClass('mega-window--open');
    $('.mega-window.open').removeClass('open');
    $('.mega-link.open').removeClass('open');
  });



})();


(function () {
  $('.wForm select').wrap('<div class="custom-select"></div>');
  console.log('ee');
  $('.js-dropdown-trigger').on('click', function (e) {
    console.log('rr');
    $(e.target).closest('.mobile-dropdown').toggleClass('open');
  });



  $('.dropdown-action').on('click', function (e) {
    e.preventDefault();
    $(e.target).parent().toggleClass('open');
  });

})();


// Add Arrow to buttons
(function () {


  $('.wp-block-button .wp-block-button__link').append('<svg class="icon arrow-right" role="img"><use xlink:href="#arrow-right"></use></svg>');

})();

var infoSlider;
(function(){
  $('.info-slider').each(function(i,el){
      infoSlider = new Swiper(el, {
        speed: 700,
        observeParents:true,
        observer:true,
        observeSlideChildren:true,
        spaceBetween: 20,  
        simulateTouch: false,
        slidesPerView:'auto',  
        autoHeight:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
       
      });

      

  });
  if ($('.info-slider').length>0) {
    $(window).on('resize',function() {
      updateSizes();
    });
    setInterval(function() {
        updateSizes();
    }, 7000);

  }

})();
function updateSizes() {

  $('.graph-slider .swiper-wrapper').css('height','');
  infoSlider.update();
}  
(function() {

  var emb = $('.embed-box');
  if ( emb.length>0 ) {
      var ratio = emb.parent().attr('data-ratio')/100;
      var areaHeight = emb.height();
      if (emb.width()*ratio > areaHeight ) {
          var inverse = (1 / ratio) * 100;  
          var dets = '<style>@media(min-width:980px) { .sticky-article .sticky-column .flourish-embed iframe { left: 50%; transform: translate(-50%, 0px);';
          dets += 'width:'+inverse+'%!important';
          dets +='} } </style>';

          $('body').append(dets);
      }
  }

})();
/* calendar */
(function () {
  app.selectAndIterate('.calendar-button', function (i, el) {

    if (el.getAttribute('data-end') && el.getAttribute('data-start')) {
      var data = {
        title: el.getAttribute('data-title'),
        start: new Date(el.getAttribute('data-start')),
        duration: parseInt(el.getAttribute('data-minutes')),
        end: new Date(el.getAttribute('data-end')),
        address: el.getAttribute('data-address'),
        description: el.getAttribute('data-desc')
      }
      var calLinks = generateCalendars(data);
      el.parentNode.innerHTML += '<div class="accordion-panel accordion-overlay menu menu-vertical"><ul><li>' + calLinks.google + '</li><li>' + calLinks.outlook + '</li><li>' + calLinks.ical + '</li><li>' + calLinks.ical + '</li><li>' + calLinks.yahoo + '</li></ul></div>';
    }
  
  });

})();





/** Home Hero Slider **/
(function () {
  $('body').on('click', '.home-hero .swiper-pagination-bullet .btn-arrow', function (e) {
    e.preventDefault();


    window.location = $(this).attr('href');


  });
  var container = document.querySelector('.home-hero .swiper-container');

  if (container === null) {
    return;
  }

  var opts = {
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    simulateTouch: false,
    allowTouchMove: false,
    pagination: {
      el: container.parentNode.parentNode.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true,
      renderBullet: function (index, className) {
        var title = this.slides[index].getAttribute('data-title');
        var cta = this.slides[index].getAttribute('data-cta');
        var date = this.slides[index].getAttribute('data-date');
        var type = this.slides[index].getAttribute('data-type');
        var url = this.slides[index].getAttribute('data-url');
        return '<span class="' + className + '"><span class="item-num">0' + (index + 1) + '</span><span class="item-detail"><p class="card-item__meta" style="6px;font-size:16px;"><span class="cat ">' + type + '</span> | ' + date + '</p><a class="btn-arrow" style="padding-top:0;" href="' + url + '" target="">' + title + '</a></span></span>';
      }
    },
  };
  new Swiper(container, opts);
})();




/** Always on slider **/
(function () {

  if ($('body').width() < 980) {
    $('.mobile-slider .swiper-container').each(function (i, container) {
      var parentEl = container.parentNode;

      var count = 4;
      if (container.getAttribute('date-columns') != undefined) {

        count = parseInt(container.getAttribute('date-columns'));
      }

      var opts = {
        spaceBetween: 0,
        slidesPerView: 3,
        slidesPerGroup: 3,
        simulateTouch: false,
        breakpoints: {
          650: {
            slidesPerView: 1,
            slidesPerGroup: 1
          },
          900: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        }
      };


      if (container.querySelector('.current-card') !== undefined) {

        var currentCard = container.querySelector('.current-card');
        // if (currentCard.getAttribute('data-index') !== undefined) {
        //   opts.initialSlide = currentCard.getAttribute('data-index');

        // }
      }

      if (parentEl.querySelector('.swiper-button-next')) {

        opts.navigation = {
          nextEl: parentEl.querySelector('.swiper-button-next'),
          prevEl: parentEl.querySelector('.swiper-button-prev'),
        };

      }


      new Swiper(container, opts);


    });

  }


  fullSliders();
})();


function fullSliders() {
  app.selectAndIterate('.full-slider .swiper-container', function (i, container) {
    var parentEl = container.parentNode;




    var count = 4;
    if (container.getAttribute('date-columns') != undefined) {

      count = parseInt(container.getAttribute('date-columns'));
    }

    var opts = {
      spaceBetween: 0,
      slidesPerView: count,
      slidesPerGroup: count,
      simulateTouch: false,
      navigation: {
        nextEl: parentEl.querySelector('.swiper-button-next'),
        prevEl: parentEl.querySelector('.swiper-button-prev')
      },
      breakpoints: {

        650: {
          slidesPerView: 1,
          slidesPerGroup: 1
        },

        900: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },

        1150: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    };


    if (container.classList.contains('tool-type-slider')) {

      opts.breakpoints = {

        650: {
          slidesPerView: 1,
          slidesPerGroup: 1
        },

        1050: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },

        1250: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    }

    new Swiper(container, opts);


  });


}








(function () {
  $('.custom-tabs-block').each(function (i, container) {

    var links = $(container).find('.tab-menu a');
    var tabs = $(container).find('.custom-tab-block');

    links.on('click', function (e) {
      e.preventDefault();
      console.log($(this).attr('href'));
      links.removeClass('active').attr('aria-expanded','false')
      tabs.removeClass('active').attr('hidden','true');
      $(this).addClass('active').attr('aria-expanded','true')
      $($(this).attr('href')).addClass('active').removeAttr('hidden');
      var drop = $(this).parents('.mobile-dropdown');
      if (drop.length>0) {
        drop.removeClass('open').find('.menu-title .drop-label').text($(this).text());

      }

    });

  });


  $('.tabs-block').each(function (i, container) {

    var links = $(container).find('.anchor-menu a');
    var tabs = $(container).find('.tab-block');

    links.on('click', function (e) {
      e.preventDefault();
      console.log($(this).attr('href'));
      links.removeClass('active');
      tabs.removeClass('active');
      $(this).addClass('active');
      $($(this).attr('href')).addClass('active');

      $('.anchor-menu.open').removeClass('open');

    });

  });




})();





/** Init sliders  **/
(function () {


  var postList = document.querySelector('.wp-block-post-list');
  var postListVisible = 4;
  var offset = -105;
  var postListBreak = {

    600: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      simulateTouch: false,
      pagination: {
        type: "fraction",
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' +
            ' of ' +
            '<span class="' + totalClass + '"></span>';
        }
      },
    },

    850: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },

    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3
    }

  };



  //addHeroSlider();
  //addTabs();
})();

function addTabs() {
  var tabBlock = document.querySelector('.wp-block-salty-tabs');

  if (tabBlock) {


    var container = tabBlock.querySelector('.swiper-container');



    app.addClass('.swiper-wrapper > *', 'swiper-slide', container);


    var opts = {

      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      simulateTouch: false,
      /*
      flipEffect: {
        rotate: 30,
        slideShadows: false,
      },
     
      effect:'flip',*/
      pagination: {
        el: tabBlock.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          var title = this.slides[index].querySelector('.tab-heading').innerHTML;
          return '<span class="' + className + '"><span class="item-title">' + title + '</span></span>';
        }
      },
      breakpoints: {
        768: {

          slideToClickedSlide: true
        }
      }
    };

    new Swiper(container, opts);


  }


}


function addHeroSlider() {
  var container = document.querySelector('.wp-block-salty-landing-hero-facts');

  if (container == undefined) return;

  var controlContainer = container.querySelector('.second-image');
  var slider
  if (container) {
    addSliderControls(controlContainer);


    var opts = {

      spaceBetween: 14,
      slidesPerView: 3,
      slidesPerGroup: 3,
      watchOverflow: true,
      simulateTouch: false,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      breakpoints: {

        650: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          pagination: {
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
              return '<span class="' + currentClass + '"></span>' +
                ' of ' +
                '<span class="' + totalClass + '"></span>';
            }
          },

        },

        900: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },

        1150: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span class="bullet-label">0' + (index + 1) + '</span></span>';
        }
      },

    };
    app.addClass('.swiper-wrapper > *', 'swiper-slide', container);
    new Swiper(container.querySelector('.swiper-container'), opts);

  }
}


(function () {

  addSlider('.single-slider', 1, true, { watchOverflow: true });

  addSlider('.cards-image__list', 3, false, {
    spaceBetween: 20,
    breakpoints: {
      850: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      1150: {
        slidesPerView: 2,
        slidesPerGroup: 2
      }
    }
  });


})();



function sliderOptions(container, perView, overrideOpts) {




  var opts = {

    spaceBetween: 0,
    slidesPerView: perView,
    slidesPerGroup: perView,
    watchOverflow: true,
    simulateTouch: false,
  };

  if (container.querySelector('.swiper-pagination')) {

    opts.pagination = {
      el: container.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true
    }
  }
  if (perView == 1) {
    opts.spaceBetween = 0;

  }
  if (overrideOpts !== undefined) opts = Object.assign(opts, overrideOpts);





  return opts;
}


function addSlider(selector, perView, addControls, customOpts) {
  var container = document.querySelector(selector);
  app.selectAndIterate(selector, function (i, container) {

    if ($(container).find('.swiper-slide').length > 1) {
      var controlsContainer = container;

      app.addClass('.swiper-wrapper > *', 'swiper-slide', container);
      if (addControls) addSliderControls(controlsContainer);

      new Swiper(container, sliderOptions(controlsContainer, perView, customOpts));

    }

  });
}


function addSliderControls(container, className) {
  if (className == undefined) {
    className = 'standard-controls';
  }


  container.innerHTML += '<div class="swiper-controls ' + className + '"><div class="swiper-pagination"></div></div>';

}


function applyGroupEffects(list) {
  list.each(function (i, item) {
    item.setAttribute('data-emergence', 'hidden');
    if (item.tagName == 'H1' || item.tagName == 'H2' || item.tagName == 'H3') {
      item.classList.add('hidden-child', 'heading-in');

      item.innerHTML = '<div><span>' + item.innerHTML + '</span></div>';
    } else {
      item.classList.add('hidden-child', 'fadeup');
    }
  });

}

(function ($) {
  app.addClass('.accordion-item', 'item');
  $('.single .anchor-menu nav a').each(function(i,el) {

      var ref = $(el).attr('href');

      if (ref.startsWith('#')) {

        var item = $(ref);

        if (item.length>0) {

          item.addClass('ignore').addClass('anchor-item').attr('data-emergence', 'hidden');
        }
      }

  });


  
  $('.hidden-child').attr('data-emergence', 'hidden');


  $('.wp-block-salty-accordion').attr('data-timing', 65);

  $('.card-slider .basic-tab:not(.active) .hidden-child').removeClass('hidden-child').removeClass('fadeup').removeAttr('data-emergence');
  $('.card-slider .basic-tab.active .hidden-child').slice(5).removeClass('hidden-child').removeClass('fadeup').removeAttr('data-emergence');
  //$('.wp-block-video > *').wrap('<div class="wipe-child"></div>');
  //$('.wp-block-image > *').wrap('<div class="wipe-child"></div>');

  $('.hero-subheading').attr('data-emergence', 'hidden').addClass('hidden-child subhead-in');

  $('.block-container > *').each(function (i, el) {
    $block = $(el);
    if (!$block.hasClass('hidden-block')) {
      $block.attr('data-emergence', 'hidden').addClass('hidden-block');
      if ($block.find('.item').length > 0) {
        $block.find('.item').each(function (i, item) {


          if (item.classList.contains('wp-block-salty-layout-column')) {
            applyGroupEffects($(item).children());

          } else if (item.classList.contains('wp-block-salty-popout-card')) {
            $(item).find('.card-link').wrap('<div class="effect"></div>').parent().attr('data-emergence', 'hidden').addClass('hidden-child wipeup');

            //item.querySelector('> *').classList.add('hidden-child','wipeup');

          } else if (item.classList.contains('overlay-card')) {

            item.querySelector('a').setAttribute('data-emergence', 'hidden');
            item.querySelector('a').classList.add('hidden-child', 'wipeup');

          } else {
            item.setAttribute('data-emergence', 'hidden');
            item.classList.add('hidden-child', 'fadeup');
          }



        });



        applyGroupEffects($block.find('.effect-group > *'));
        applyGroupEffects($block.find('.wp-block-salty-section-title > .content-block > *'));


      } else {
        if (!$block.hasClass('hidden-child')) {
          if ($block.hasClass('wp-block-video')) {
            $block.addClass('hidden-child wipe-children');
          } else if ($block.hasClass('wp-block-image')) {
            $block.addClass('hidden-child wipe-children');
          } /*else if ($block.hasClass('wp-block-group')) {
                  $block.addClass('hidden-child wipeup ani-darkgreen');
              }*/ else {
            $block.addClass('hidden-child fadeup');
          }


        }
      }

    }

  });


  var $body = $('body');

  var cushion = 0.15;
  if ($body.width() < 600) {
    cushion = 0.05;
  }
  $body.addClass('page-visible');
  emergence.init({
    elemCushion: cushion,
    callback: function (element, state) {

      if (state === 'reset') {

        var $el = $(element);

        if ($el.hasClass('autovideo')) {
          $el[0].pause();


        }

        if ($el.hasClass('autohome')) {


          home.pause();


        }
        if ($el.hasClass('anchor-item') && $el.hasClass('anchor-on')) {

          $el.removeClass('anchor-on')
        }
      }
      if (state === 'visible') {

        var $el = $(element);

        if ($el.hasClass('anchor-item') && !$el.hasClass('anchor-on')) {

          $el.addClass('anchor-on')
          $('.anchor-menu nav a').removeClass('active');

          var menuItem = $('.anchor-menu nav a[href="#'+$el.attr('id')+'"]');
          menuItem.addClass('active');
          console.log(menuItem);
          var menuOffset = $('.anchor-menu').find('.menu').offset();
          $('.anchor-menu .line').css({ 'left': menuItem.offset().left - menuOffset.left, 'width': menuItem.width() });
        }


        var container = $(element);
        var timing = 65;
        if (!container.hasClass('hidden-block')) {
          var parent = container.parents('.hidden-block');
          if (parent.length>0) {
            container = parent;
          }
        }
        if (container[0].hasAttribute("data-timing")) {
          timing = container.attr("data-timing");
        }
        if (!container.hasClass('ignore')) {
          if (container.hasClass('proxy-element')) {
            container.find('[data-emergence]').not('.ignore').removeAttr('data-emergence');
          }
          container.removeAttr('data-emergence');
        } else {

          if (container.hasClass('autovideo')) {
            container[0].play()

          }

          if ($el.hasClass('autohome')) {


            home.play();


          }

        }


        if (!container.hasClass('reveal-complete')) {
          container.addClass('reveal-complete');

          var subItems = container.find('.hidden-child').not('.revealed');;

          if (subItems.length > 0 && !subItems.eq(0).hasClass('revealed')) {
            emergeItems(subItems, timing);
          } else {
            container.addClass('revealed');
          }
        }


      }



    }







  });


  var articleItems = $('.article').find('.hidden-child').not('.revealed');
  if (articleItems.length) {

    setTimeout(function () {
      $('.article').addClass('reveal-complete');
      emergeItems(articleItems, 65);
    }, 3000);
  }


  function emergeItems(items, timing) {
    var rxp = new RegExp("([0-9]+\.?[0-9]+)", "gm");
    items.each(function (i, el) {
      setTimeout(function () {
        var $el = $(el);
        $(el).addClass('revealed');
        /*if ($el.hasClass('wp-block-salty-fact-card')) {
            console.log('stat');
             $el.find('h3').each(function(i,hel) {
                  var content = hel.innerHTML;


                  console.log(content+'  '+content.replace(/([0-9]+[.,][0-9]+|[0-9]+)/g, '<span class="num">$&</span>'))
                  hel.innerHTML = content.replace(/([0-9]+[.,][0-9]+|[0-9]+)/g, '<span class="num">$&</span>');
                  

                  var numb = hel.querySelector('.num');

                  if (numb) {

                    var value = numb.innerHTML.replace(/,/, '');

                    var final =  parseFloat(value);
                    var options = {
                      
                      
                    }; 
                    if (!Number.isInteger(final)) {

                      options.decimalPlaces = 2;

                    }
                    

                  
                    var count = new CountUp(numb, final,options);
                    count.start();

                  }



              });

        }*/


      }, timing * i);


    });

  }


  $('.block-container > *').eq(0).each(function (i, el) {
    var container = $(el);
    if (!container.hasClass('reveal-complete')) {
      container.find('[data-emergence]').not('.ignore').removeAttr('data-emergence').addClass('reveal-complete');
      var subItems = container.find('.hidden-child').not('.revealed');

      if (subItems.length > 0 && !subItems.eq(0).hasClass('revealed')) {
        emergeItems(subItems, 65);
      } else {
        container.addClass('revealed');


      }
    }


  });






})(jQuery);


function updateFilterCount(form, button) {
  if (form !== null && button !== null) {
    var count = form.querySelectorAll('input[type="checkbox"]:checked').length;
    var countName = count;
    if (count == 0) {
      countName = '';
    }

    button.querySelector('.count').innerHTML = countName;
  }



}


(function () {




  var filtersForm = document.querySelector('#list-filters');
  var toggle = document.querySelector('.main-filters .dropdown-action');
  if (filtersForm !== null) {
    app.onClick('reset-form', function (e) {
      e.preventDefault();


      filtersForm.reset();
    });

    updateFilterCount(filtersForm, toggle);

    filtersForm.addEventListener('change', function (e) {

      updateFilterCount(filtersForm, toggle);

    });
    filtersForm.addEventListener('submit', function (e) {
      e.preventDefault();


      var container = $('<div class="post-list-page"></div>');


      container.load($(filtersForm).attr('action') + ' #post-list', $(filtersForm).serialize(), function (e) {
        app.removeClass('.main-filters', 'open');

        var items = container.find('.item');





        $('#post-list').find('.ajax-list-container').html(items);

        $('#post-list').find('.filter-bar--page-count').html(container.find('.filter-bar--page-count').html());
        $('#post-list').find('.list-paging').html(container.find('.list-paging').html());


        var pos = $(filtersForm).offset().top - 150;
        items.addClass('hidden-block hidden-child fadeup');
        $('html,body').animate({
          scrollTop: pos
        }, 800);

        items.not('.reveal-complete').each(function (i, el) {
          setTimeout(function () {

            $(el).addClass(' reveal-complete revealed');

          }, 125 * i);


        });




      });



    });


  }



  $('#post-list').on('click', '.ajax-paging a', function (e) {
    e.preventDefault();

    var button = $(this);
    var container = $('<div class="post-list-page"></div>');


    var pos = $(filtersForm).offset().top - 150;

    $('html,body').animate({
      scrollTop: pos
    }, 800);

    container.load($(this).attr('href') + ' #post-list', function (e) {


      var items = container.find('.item');

      items.each(function (i, el) {


        if (el.classList.contains('accordion-item')) {
          el.innerHTML += '<span class="accordion-marker"></span>';
          el.classList.add('closed');
        }
      });



      $('#post-list').find('.ajax-list-container').empty().html(items);

      $('#post-list').find('.filter-bar--page-count').html(container.find('.filter-bar--page-count').html());
      $('#post-list').find('.list-paging').html(container.find('.list-paging').html());

      items.addClass('hidden-block hidden-child fadeup');


      items.not('.reveal-complete').each(function (i, el) {
        setTimeout(function () {

          $(el).addClass(' reveal-complete revealed');

        }, 125 * i);


      });


    });
  })

})();



(function () {
  if ($('.video-placeholder').length > 0) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


    $('.video-placeholder').each(function (i, btn) {
      var container = $(btn.parentNode);

      container.find('iframe').attr('id', 'youplayer-' + i);


    });

  }




  $('.video-placeholder').append('<div class="video-play"><svg class="icon arrow-up" aria-hidden="true" role="img"><use xlink:href="#play"></use></svg><p>WATCH THE VIDEO</p></div>')


})();

function onYouTubeIframeAPIReady() {
  console.log('ready');
  $('.video-placeholder').each(function (i, btn) {
    var container = $(btn.parentNode);


    var player = new YT.Player('youplayer-' + i, {

      events: {
        // 'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });


    player.ref = $('#youplayer-' + i);
    $(btn).attr('data-id', 'youplayer-' + i).on('click', function (e) {
      e.preventDefault();


      player.playVideo();


    });

  });

  function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {

      event.target.ref.parents('.wp-block-salty-youtube').addClass('playing');
    }

    if (event.data == YT.PlayerState.ENDED) {

      event.target.ref.parents('.wp-block-salty-youtube').removeClass('playing');
    }


  }

}

(function () {
  var elements1 = document.querySelectorAll('.wp-block-salty-page-hero-story .wp-block-salty-layout-column:first-child');
  if (elements1!==undefined && elements1.length > 0) {
    Stickyfill.add(elements1);
  }

  var elements2 = document.querySelectorAll('.wp-block-salty-sticky-article .sticky-column');
  if (elements2!==undefined && elements2.length > 0) {
    Stickyfill.add(elements2);
  }
  var elements3 = document.querySelectorAll('.events-map');
  if (elements3!==undefined && elements3.length > 0) {
    Stickyfill.add(elements3);
  }


})();



(function () {
  app.onClick('.expandible .expandible-toggle', function (e) {
    e.preventDefault();

    var block = e.target.closest('.expandible');
    block.classList.toggle('closed');
    console.log(block);
    if (block.classList.contains('closed')) {
      e.target.innerHTML = 'Show More';
    } else {
      e.target.innerHTML = 'Show Less';
    }
  });

  app.selectAndIterate('.expandible', function (b, block) {
    block.classList.add('closed');



  });
})();



/** add button Arrows **/
(function () {

  $('.rte .btn-arrow').each(function (i, el) {
    if ($(el).find('svg').length == 0) {

      $(el).append('<svg class="icon arrow-right ignore-text-color" aria-hidden="true" role="img"><use xlink:href="#arrow-right"></use></svg>');

    }

  });
})();

(function () {
  var box = document.querySelector('.wp-block-salty-page-hero-event');


  app.selectAndIterate('.accordion-item', function (i, item) {

    if (!$(item).hasClass('no-icon')) {
      $(item).find('.js-accordion-title').append('<svg class="plus" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42"><g  transform="translate(-203 -5353)"><g  transform="translate(245 5395) rotate(180)" fill="none" stroke="currentColor" stroke-width="3"><circle cx="21" cy="21" r="21" stroke="none"/><circle cx="21" cy="21" r="18.5" fill="none"/></g><line x2="16" transform="translate(216.5 5374.5)" fill="none" stroke="currentColor" stroke-width="3"/><line class="line" x2="16" transform="translate(224.5 5366.5) rotate(90)" fill="none" stroke="currentColor" stroke-width="3"/></g></svg>');


    }
    if (!$(item).hasClass('default-open')) {

      $(item).addClass('closed');
    } else {
      $(item).find('.accordion-panel').show();
    }


  });

  app.selectAndIterate('.accordion-item-mobile', function (i, item) {
    $(item).find('.js-accordion-title').append('<svg class="plus" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42"><g  transform="translate(-203 -5353)"><g  transform="translate(245 5395) rotate(180)" fill="none" stroke="currentColor" stroke-width="3"><circle cx="21" cy="21" r="21" stroke="none"/><circle cx="21" cy="21" r="18.5" fill="none"/></g><line x2="16" transform="translate(216.5 5374.5)" fill="none" stroke="currentColor" stroke-width="3"/><line class="line" x2="16" transform="translate(224.5 5366.5) rotate(90)" fill="none" stroke="currentColor" stroke-width="3"/></g></svg>');

    if (!$(item).hasClass('ignore')) {
      $(item).addClass('closed');

    }


  });

  $('.tab-list .accordion-items').each(function (i, el) {
    var tabListBlock = $(el);
    var tabListItems = tabListBlock.find('.accordion-item-hidden');
    console.log(tabListItems.length);
    if (tabListItems.length > 0) {

      tabListBlock.parent().append('<div class="more-accordions__container hidden-child fadeup"><a href="#" class="js-link more-accordions btn-secondary">Load more</a></div>');


      tabListBlock.parent().find('.more-accordions').on('click', function (e) {
        e.preventDefault();
        var revealItems = tabListItems.slice(0, 4);
        revealItems.removeClass('accordion-item-hidden');
        tabListItems = tabListBlock.find('.accordion-item-hidden');
        if (tabListItems.length == 0) {
          $(this).remove();

        }
      });
    }
  });



  $('.hidden-items').each(function (i, el) {
    var tabListBlock = $(el);
    tabListBlock.find( ".item:gt(4)" ).addClass('item-hidden');
    
    var tabListItems = tabListBlock.find('.item-hidden');
    console.log(tabListItems.length);
    if (tabListItems.length > 0) {

      tabListBlock.parent().append('<div class="more-accordions__container hidden-child fadeup" style="margin-top:30px;"><a href="#" class="js-link more-items btn-primary">Load more</a></div>');


      tabListBlock.parent().find('.more-items').on('click', function (e) {
        e.preventDefault();
        var revealItems = tabListItems.slice(0, 4);
        revealItems.removeClass('item-hidden');
        tabListItems = tabListBlock.find('.item-hidden');
        if (tabListItems.length == 0) {
          $(this).remove();

        }
      });
    }
  });



  $('.accordion-item .js-accordion-title').on('click', function (e) {

    var $current = $(this);

    if (!$current.hasClass('accordion-item')) {
      $current = $current.parents('.accordion-item');
    }


    var container = $current.parent();
    var items = container.find('.accordion-item');


    if ($current.hasClass('closed')) {
      $current.find('.accordion-panel').removeAttr('hidden').slideDown();
      $current.removeClass('closed');
      $(this).attr('aria-expanded','true');

    } else {
      $current.find('.accordion-panel').attr('hidden','true').slideUp();
      $current.addClass('closed');
      $(this).attr('aria-expanded','false');
    }
  });

  $('.accordion-item-mobile .js-accordion-title').on('click', function (e) {

    var $current = $(this);

    if (!$current.hasClass('accordion-item')) {
      $current = $current.parents('.accordion-item-mobile');
    }


    var container = $current.parent();
    var items = container.find('.accordion-item-mobile');

    if ($current.hasClass('closed')) {
      $current.find('.accordion-panel').slideDown();
      $current.removeClass('closed');


    } else {
      $current.find('.accordion-panel').slideUp();
      $current.addClass('closed');

    }
  });


  if (box !== null) {
    if ($('body').width() > 768) {
      var item = box.querySelector('.accordion-item');

      if (item !== null) {
        item.classList.remove('closed');
      }

    }
  }
})();

app.activeMarkers = [];
app.mapObj;

app.markers = [];
app.infowindow;
app.autoCompBox;
window.initialize = function () {
  if (document.querySelector('#map-block')) {
    initMap('#map-block');
  }


}

function loadMaps(callback) {
  if (window.google == undefined) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCm0Z-oIKhqBP-s5VSQcuR9H5aC85jdtv4&libraries=places&callback=' + callback;
    document.body.appendChild(script);

  } else {
    var fn = window[callback];
    if (typeof fn === 'function') {
      fn();
    }
  }


}

function updateMarkers(mapObj) {
  for (var i = 0; i < locations.length; i++) {

    addMarker(mapObj, locations[i], true);
  }


}


var currentMarker;

function addMarker(mapObj, markerData, showMarkerInfo) {
  var latLng = new google.maps.LatLng(markerData.lat, markerData.lng);
  console.log(markerData);
  var marker = new google.maps.Marker({
    position: latLng,
    map: mapObj,
    optimized: false,
    icon: (markerData.markerColor == 'red') ? app.redIcon : app.blueIcon
  });
  marker.mData = markerData;

  app.activeMarkers.push(marker);

  if (showMarkerInfo) {

    //markerData.distance = Math.round((google.maps.geometry.spherical.computeDistanceBetween(markers[0].marker.getPosition(),marker.getPosition())*0.000621371192)*10)*0.1;


    google.maps.event.addListener(marker, 'click', function () {
      if (currentMarker !== undefined) {
        currentMarker.setIcon((currentMarker.mData.markerColor == 'red') ? app.redIcon : app.blueIcon);
        currentMarker = undefined;
      }

      console.log('open');
      $('.map-overlay__heading').html(markerData.title);
      $('.map-overlay__content').html(markerData.intro);
      $('.map-overlay__cta').html(markerData.button);

      $('.map-overlay').addClass('open');
      console.log(markerData);
      currentMarker = marker;

      marker.setIcon((markerData.markerColor == 'red') ? app.bigRedIcon : app.bigBlueIcon);
      //app.infowindow.setContent('<div class="marker-info-window"><div class="fluid">'+markerData.image+'</div><div class="marker-info-window__content"><p class="marker-info-window__date small-heading">'+markerData.date+'</p><h3 class="marker-info-window__title">'+markerData.title+'</h3><a class="btn-arrow" href="'+markerData.url+'">View Event</a></div></div>');
      //app.infowindow.open(mapObj, marker);
    });

  }
  return marker;
}

function initMap(selector) {
  //getMarkerData();
  $('.map-overlay__close').on('click', function (e) {
    e.preventDefault();

    $('.map-overlay').removeClass('open');

    if (currentMarker !== undefined) {
      currentMarker.setIcon((currentMarker.mData.markerColor == 'red') ? app.redIcon : app.blueIcon);
      currentMarker = undefined;
    }

  });

  app.blueIcon = {
    url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4wNzIiIGhlaWdodD0iMTguNDE0IiB2aWV3Qm94PSIwIDAgMTUuMDcyIDE4LjQxNCI+ICA8cGF0aCBkPSJNMjAuOTMsMi4xOTRhNy40OSw3LjQ5LDAsMCwwLTEwLjU5NCwwLDguMzg2LDguMzg2LDAsMCwwLS43LDEwLjUyOCwyNS43MiwyNS43MiwwLDAsMCw2LDUuNjkyLDE3LjgxNSwxNy44MTUsMCwwLDAsNS45OTItNS42OEMyNC4wMTEsOC45NjMsMjMuNTQ4LDQuODEyLDIwLjkzLDIuMTk0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTguMTA3KSIgZmlsbD0iIzE0OTRlNyIvPjwvc3ZnPg==',
    scaledSize: new google.maps.Size(15, 19)
  };

  app.redIcon = {
    url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4wNzIiIGhlaWdodD0iMTguNDE0IiB2aWV3Qm94PSIwIDAgMTUuMDcyIDE4LjQxNCI+ICA8cGF0aCBpZD0icGxhY2Vob2xkZXIiIGQ9Ik0yMC45MywyLjE5NGE3LjQ5LDcuNDksMCwwLDAtMTAuNTk0LDAsOC4zODYsOC4zODYsMCwwLDAtLjcsMTAuNTI4LDI1LjcyLDI1LjcyLDAsMCwwLDYsNS42OTIsMTcuODE1LDE3LjgxNSwwLDAsMCw1Ljk5Mi01LjY4QzI0LjAxMSw4Ljk2MywyMy41NDgsNC44MTIsMjAuOTMsMi4xOTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOC4xMDcpIiBmaWxsPSIjZmY2YTU4Ii8+PC9zdmc+',
    scaledSize: new google.maps.Size(15, 19)
  };
  app.bigBlueIcon = {
    url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MC41MzYiIGhlaWdodD0iNDkuNTI0IiB2aWV3Qm94PSIwIDAgNDAuNTM2IDQ5LjUyNCI+ICA8ZyBpZD0iR3JvdXBfNjIyMCIgZGF0YS1uYW1lPSJHcm91cCA2MjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg5IC0zNjAuNDk1KSI+ICAgIDxwYXRoIGlkPSJwbGFjZWhvbGRlciIgZD0iTTQyLjU5NCw1LjlhMjAuMTQ1LDIwLjE0NSwwLDAsMC0yOC40OSwwYy03LjA0Miw3LjA0MS04LjE1LDE5LjQ5NC0xLjksMjguMzE0czE2LjE0LDE1LjMwOSwxNi4xNCwxNS4zMDlBNDcuOTExLDQ3LjkxMSwwLDAsMCw0NC40NjUsMzQuMjQ3QzUwLjg3OSwyNC4xMDYsNDkuNjM2LDEyLjk0Miw0Mi41OTQsNS45WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTgwLjg5MyAzNjAuNDk1KSIgZmlsbD0iIzE0OTRFNyIvPiAgICA8ZyBpZD0iR3JvdXBfNTYxNiIgZGF0YS1uYW1lPSJHcm91cCA1NjE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1OTcuNjg0IDM2OC4wMTEpIj4gICAgICA8cGF0aCBpZD0iUGF0aF8yNDM3IiBkYXRhLW5hbWU9IlBhdGggMjQzNyIgZD0iTTE1LjYwNiw0YS41NjkuNTY5LDAsMCwwLS4yODQuMDc5bC0xMC42LDcuMDY0YS41LjUsMCwwLDAsLjI4NC45M0g2LjUyM1YyMi4xNjVINS4wMDlhLjUyNC41MjQsMCwwLDAtLjUuNXYxLjUxNGEuNTI0LjUyNCwwLDAsMC0uNS41djIuMDE4YS41MjQuNTI0LDAsMCwwLC41LjVoMjIuMmEuNTI0LjUyNCwwLDAsMCwuNS0uNVYyNC42ODhhLjUyNC41MjQsMCwwLDAtLjUtLjVWMjIuNjdhLjUyNC41MjQsMCwwLDAtLjUtLjVIMjQuNjg4VjEyLjA3M0gyNi4yYS41LjUsMCwwLDAsLjI4NC0uOTNMMTUuODksNC4wNzlBLjQ1My40NTMsMCwwLDAsMTUuNjA2LDRabTAsMS4xMTIsOC45MjUsNS45NTNINi42ODFabTAsMS42NjRhMS43NjYsMS43NjYsMCwxLDAsMS43NjYsMS43NjZBMS43NzQsMS43NzQsMCwwLDAsMTUuNjA2LDYuNzc1Wm0wLDEuMDA5YS43NTcuNzU3LDAsMSwxLS43NTcuNzU3QS43NDkuNzQ5LDAsMCwxLDE1LjYwNiw3Ljc4NFpNNy41MzIsMTIuMDczSDguNTQxVjIyLjE2NUg3LjUzMlptMi4wMTgsMGgyLjAxOFYyMi4xNjVIOS41NTFabTMuMDI4LDBoMS4wMDlWMjIuMTY1SDEyLjU3OFptMi4wMTgsMGgyLjAxOFYyMi4xNjVIMTQuNlptMy4wMjgsMGgxLjAwOVYyMi4xNjVIMTcuNjI0Wm0yLjAxOCwwaDIuMDE4VjIyLjE2NUgxOS42NDJabTMuMDI4LDBoMS4wMDlWMjIuMTY1SDIyLjY3Wk01LjUxNCwyMy4xNzVIMjUuN3YxLjAwOUg1LjUxNFptLS41LDIuMDE4SDI2LjJWMjYuMkg1LjAwOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00IC00KSIgZmlsbD0iI2ZmZDEzOSIgc3Ryb2tlPSIjZmZkMTM5IiBzdHJva2Utd2lkdGg9IjAuMjUiLz4gICAgPC9nPiAgPC9nPjwvc3ZnPg==',
    scaledSize: new google.maps.Size(40, 49)
  }
  app.bigRedIcon = {
    url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MC41MzYiIGhlaWdodD0iNDkuNTI0IiB2aWV3Qm94PSIwIDAgNDAuNTM2IDQ5LjUyNCI+ICA8ZyBpZD0iR3JvdXBfNjIyMCIgZGF0YS1uYW1lPSJHcm91cCA2MjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg5IC0zNjAuNDk1KSI+ICAgIDxwYXRoIGlkPSJwbGFjZWhvbGRlciIgZD0iTTQyLjU5NCw1LjlhMjAuMTQ1LDIwLjE0NSwwLDAsMC0yOC40OSwwYy03LjA0Miw3LjA0MS04LjE1LDE5LjQ5NC0xLjksMjguMzE0czE2LjE0LDE1LjMwOSwxNi4xNCwxNS4zMDlBNDcuOTExLDQ3LjkxMSwwLDAsMCw0NC40NjUsMzQuMjQ3QzUwLjg3OSwyNC4xMDYsNDkuNjM2LDEyLjk0Miw0Mi41OTQsNS45WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTgwLjg5MyAzNjAuNDk1KSIgZmlsbD0iI2ZmNmE1OCIvPiAgICA8ZyBpZD0iR3JvdXBfNTYxNiIgZGF0YS1uYW1lPSJHcm91cCA1NjE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1OTcuNjg0IDM2OC4wMTEpIj4gICAgICA8cGF0aCBpZD0iUGF0aF8yNDM3IiBkYXRhLW5hbWU9IlBhdGggMjQzNyIgZD0iTTE1LjYwNiw0YS41NjkuNTY5LDAsMCwwLS4yODQuMDc5bC0xMC42LDcuMDY0YS41LjUsMCwwLDAsLjI4NC45M0g2LjUyM1YyMi4xNjVINS4wMDlhLjUyNC41MjQsMCwwLDAtLjUuNXYxLjUxNGEuNTI0LjUyNCwwLDAsMC0uNS41djIuMDE4YS41MjQuNTI0LDAsMCwwLC41LjVoMjIuMmEuNTI0LjUyNCwwLDAsMCwuNS0uNVYyNC42ODhhLjUyNC41MjQsMCwwLDAtLjUtLjVWMjIuNjdhLjUyNC41MjQsMCwwLDAtLjUtLjVIMjQuNjg4VjEyLjA3M0gyNi4yYS41LjUsMCwwLDAsLjI4NC0uOTNMMTUuODksNC4wNzlBLjQ1My40NTMsMCwwLDAsMTUuNjA2LDRabTAsMS4xMTIsOC45MjUsNS45NTNINi42ODFabTAsMS42NjRhMS43NjYsMS43NjYsMCwxLDAsMS43NjYsMS43NjZBMS43NzQsMS43NzQsMCwwLDAsMTUuNjA2LDYuNzc1Wm0wLDEuMDA5YS43NTcuNzU3LDAsMSwxLS43NTcuNzU3QS43NDkuNzQ5LDAsMCwxLDE1LjYwNiw3Ljc4NFpNNy41MzIsMTIuMDczSDguNTQxVjIyLjE2NUg3LjUzMlptMi4wMTgsMGgyLjAxOFYyMi4xNjVIOS41NTFabTMuMDI4LDBoMS4wMDlWMjIuMTY1SDEyLjU3OFptMi4wMTgsMGgyLjAxOFYyMi4xNjVIMTQuNlptMy4wMjgsMGgxLjAwOVYyMi4xNjVIMTcuNjI0Wm0yLjAxOCwwaDIuMDE4VjIyLjE2NUgxOS42NDJabTMuMDI4LDBoMS4wMDlWMjIuMTY1SDIyLjY3Wk01LjUxNCwyMy4xNzVIMjUuN3YxLjAwOUg1LjUxNFptLS41LDIuMDE4SDI2LjJWMjYuMkg1LjAwOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00IC00KSIgZmlsbD0iI2ZmZDEzOSIgc3Ryb2tlPSIjZmZkMTM5IiBzdHJva2Utd2lkdGg9IjAuMjUiLz4gICAgPC9nPiAgPC9nPjwvc3ZnPg==',
    scaledSize: new google.maps.Size(40, 49)
  };


  var container = document.querySelector(selector);


  container.classList.add('init');
  var mapOptions;

  var centerPoint = new google.maps.LatLng(52.5333946, -4.650362);
  var zoom = 7;
  if ($('body').width() < 850) {
    centerPoint = new google.maps.LatLng(53.2274728, -2.26596);
    zoom = 5;
  }


  var style = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#EAF5FD"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#EAF5FD"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#B9C8D4"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    }
  ];

  // if (device.touch) {
  mapOptions = {
    center: centerPoint,
    zoom: zoom,
    scrollwheel: false,
    navigationControl: false,
    mapTypeControl: false,
    scaleControl: false,
    fullscreenControl: false,
    disableDoubleClickZoom: false,
    disableDefaultUI: false,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
    //draggable: container.hasClass('no-scale'),
    mapTypeId: google.maps.MapTypeId.ROADMAP
  };

  app.mapObj = new google.maps.Map(container, mapOptions);


  app.mapObj.setOptions({ styles: style });



  updateMarkers(app.mapObj);
  if ($('body').width() > 900) {
    setTimeout(function () {

      new google.maps.event.trigger(app.activeMarkers[0], 'click');
    }, 400);

  }

}


(function () {


  if (document.querySelector('#map-block')) {

    loadMaps('initialize');
  }

})();





(function () {

  app.onClick('.toggle-buttons button', function (e) {
    e.preventDefault();


    app.removeClass('.toggle-buttons button', 'active');
    e.selectedTarget.classList.add('active');


    var block = document.querySelector('.toggle-container');


    if (e.selectedTarget.hasAttribute('data-add')) {

      block.classList.add(e.selectedTarget.getAttribute('data-add'));

    } else {
      block.classList.remove(e.selectedTarget.getAttribute('data-remove'));
    }
  });


})();



(function () {
  $('.basic-tab-group').each(function (i, el) {


    var group = $(el);
    var links = group.find('.basic-tab-selector a');
    links.on('click', function (e) {
      e.preventDefault();

      var newTab = $($(this).attr('href'));
      console.log(newTab);

      if (newTab.length > 0) {
        group.find('.basic-tab').removeClass('active');
        newTab.addClass('active');
        links.removeClass('selected');
        $(this).addClass('selected');

        var slider = newTab.find('.swiper-container');

        if (slider.length > 0) {

          console.log(slider[0].swiper);
          slider[0].swiper.update();

        }

      }


    });


  });


  $('.region-tool-modal-close').on('click', function (e) {
    e.preventDefault();

    $('.region-tool-modal').removeClass('open');

  });

  $('.sub-tab-selector').on('change', function () {
    console.log($(this).val());

    var newTab = $('.' + $(this).val());


    if (newTab.length > 0) {
      $('.sub-tab').removeClass('active');
      newTab.addClass('active');


    }

    if ($('.single-tools').length > 0) {
      var index = $(this).prop('selectedIndex')
      $('.sub-tab-selector').prop('selectedIndex', index);
      // $('.sub-tab-selector').val($(this).val());
      $('.region-tool-modal').addClass('open');

    }
  });

})();



/** Search Tags **/

(function () {
  var opts = '';


  $('#search-results').on('submit', '.ajax-search', function (e) {
    e.preventDefault();
    var form = $(this);

    searchValues.getResults(form.attr('action'), form.serializeArray());


  });


  $('#search-results').on('click', '.ajax-btn', function (e) {
    e.preventDefault(); // avoid to execute the actual submit of the form.
    var btn = $(this);

    searchValues.getResults(btn.attr('href'));


  });




  //if ($('.smart-search').length==0) return;


  /* for (var i=0; i<dataChoice.length; i++) {
     opts +='<optgroup label="'+dataChoice[i].label+'">';
     for (var j=0; j<dataChoice[i].choices.length; j++) {
         opts +='<option data-group="'+dataChoice[i].label+'" value="'+dataChoice[i].choices[j].value+'">'+dataChoice[i].choices[j].label+'</option>';

     }
     opts +='</optgroup>';

   }


   if ($('#term-field').val()!==undefined) {
     opts += '<optgroup label="Term"><option data-group="Term" value="'+$('#term-field').val()+'">'+$('#term-field').val()+'</option></optgroup>';
   }*/
  function slugify(text) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  var searchValues = {
    type: '',
    topics: [],
    term: '',
    status: '',
    funding: '',
    publication: '',
    setup: function () {


      if ($('#term-field').val() !== undefined) {
        var slug = slugify($('#term-field').val());
        console.log($('.smart-search').find("option[value='" + slug + "']"));
        if ($('.smart-search').find("option[value='" + slug + "']").length) {
          searchValues.term = '';
          console.log('find term');

          $('.smart-search').val(slug).trigger('change');
          $('#term-field').val('');
          if ($('.term-filter').find("option[value='" + slug + "']").length > 0) {

            $('.term-filter').val(slug);

            searchValues.getResults($('.ajax-search').attr('action'), $('.ajax-search').serializeArray());
          } else if ($('.type-filter').find("option[value='" + slug + "']").length > 0) {

            $('.type-filter').val(slug);

            searchValues.getResults($('.ajax-search').attr('action'), $('.ajax-search').serializeArray());
          }





        } else {
          searchValues.term = $('#term-field').val();
          if (searchValues.term !== undefined && searchValues.term.length > 0) {

            // Create a DOM Option and pre-select by default
            var newOption = new Option(searchValues.term, searchValues.term, true, true);
            // Append it to the select
            $('.smart-search').append(newOption).trigger('change');

          }

        }
      }
      if ($('.type-filter').val() !== null) {
        searchValues.type = $('.type-filter').val();
      }

      if ($('.status-filter').val() !== null) {
        searchValues.status = $('.status-filter').val();
      }
      if ($('.funding-filter').val() !== null) {
        searchValues.funding = $('.funding-filter').val();
      }
      if ($('.term-filter').val() !== null) {
        searchValues.topics = $('.term-filter').val();
      }

      if ($('.publication-filter').val() !== null) {
        searchValues.publication = $('.publication-filter').val();
      }

      if ($('.smart-search').length > 0) {
        $('.smart-search').val(searchValues.getValues()).trigger("change");
      }



    },
    getPageingList: function (url) {

      var container = $('<div class="loaded-data" style="visibility:visible;"></div>');


      container.load(url + ' #search-results-contents', function (e) {
        updatePageingSearch();
      });




      function updatePageingSearch() {



        if ($('#search-results').length > 0) {


          console.log(container.find('.filter-footer').html());
          console.log(container.find('.search-grid-inner .item'));
          console.log(container.find('.page-count'));
          $('#search-results .page-count').html(container.find('.page-count').html());
          $('#search-results .filter-footer').html(container.find('.filter-footer').html());

          var newBlock = container.find('.search-grid-inner .item');
          $('#search-results .search-grid-inner').append(newBlock);
          // setupFilters();

          newBlock.not('.reveal-complete').each(function (i, el) {
            setTimeout(function () {

              $(el).addClass(' reveal-complete revealed');

            }, 80 * i);


          });


          var pos = newBlock.eq(0).offset().top;

          $('html,body').animate({
            scrollTop: pos
          }, 800);

          //setup();

        }




      }


    },
    getResults: function (url, data) {
     

      var container = $('<div class="loaded-data" style="visibility:visible;"></div>');

      if (data == undefined) {
        container.load(url + ' #search-results-contents', function (e) {
          updatePage();
        });

      } else {

        data.push({ name: "ajax", value: "yes" });
        container.load(url + ' #search-results-contents', data, function (e) {
          updatePage();
        });
      }



      function updatePage() {

        container.find('.ajax-search').addClass('reveal-complete revealed');


        if ($('#search-results').length > 0) {
          $('#search-results').empty().append(container);
        }
        if ($('#result-counter').length > 0) {
          var oldCount = parseInt($('.results-count').text());
          var newCount = parseInt(container.find('.results-count').text());

          

          var demo = new CountUp('result-counter', newCount, {
            startVal: oldCount,
            duration: 1,
          });
          if (!demo.error) {
            demo.start();
          } else {
            console.error(demo.error);
          }


        }

        var pos = $('#search-results').offset().top;

        $('html,body').animate({
          scrollTop: pos
        }, 800);

       


        if ($('#search-results').length > 0) {
          setupFilters();




          searchValues.setup();

          fullSliders();
          if (history.replaceState) {

            history.replaceState({ page: 3 }, "Search", "?" + $.param(data));
          }




          container.find('.hidden-child').not('.reveal-complete').each(function (i, el) {
            setTimeout(function () {

              $(el).addClass(' reveal-complete revealed');

            }, 80 * i);


          });
        }





      }


    },
    clear: function () {
      var values = [];

      searchValues.type = '';
      searchValues.status = '';
      searchValues.funding = '';
      searchValues.publication = '';
      searchValues.term = '';
      searchValues.topics = [];

      searchValues.updateFilters();
    },
    getValues: function () {
      var values = [];
      if (searchValues.type !== '') {
        values.push(searchValues.type);
      }
      if (searchValues.type == 'reports') {
        if (searchValues.publication !== '') {
          values.push(searchValues.publication);
        }
      }
      if (searchValues.type == 'project') {

        if (searchValues.status !== '') {
          values.push(searchValues.status);
        }

        if (searchValues.funding !== '') {
          values.push(searchValues.funding);
        }

      }

      if (searchValues.topics !== undefined && searchValues.topics.length > 0) {
        values = values.concat(searchValues.topics)
      }



      if (searchValues.term !== undefined && searchValues.term.length > 0) {
        values.push(searchValues.term);
      }

      return values;
    },

    addValue: function (filter, tag) {

      console.log(filter);
      console.log(tag);
      if (filter == 'Types') {
        searchValues.type = tag;
      }
      if (filter == 'Status') {
        searchValues.status = tag;
      }
      if (filter == 'Funding') {
        searchValues.funding = tag;
      }
      if (filter == 'Report types') {
        searchValues.funding = tag;
      }
      if (filter == 'Categories') {
        searchValues.addTopic(tag);
      }
    },


    removeValue: function (filter, tag) {
      console.log(filter);
      console.log(tag);
      if (filter == 'Types') {
        searchValues.type = '';

      }
      if (filter == 'Status') {
        searchValues.status = '';
      }
      if (filter == 'Funding') {
        searchValues.funding = '';
      }

      if (filter == 'Report types') {
        searchValues.funding = '';
      }

      if (filter == 'Categories') {
        searchValues.removeTopic(tag)
      }

    },
    addTopic: function (topic) {
      var t = topic.toString();


      searchValues.topics.push(t);
    },
    removeTopic: function (topic) {
      var t = topic.toString();

      console.log(t);
      console.log('remove ' + t);
      console.log(searchValues.topics.indexOf(t));

      searchValues.topics = jQuery.grep(searchValues.topics, function (value) {
        return value != t;
      });



      console.log(searchValues.topics);


    },
    updateFilters: function (stopLoad) {
      if ($('.smart-search').length > 0) {
        $('.smart-search').val(searchValues.getValues()).trigger("change");
        $('.type-filter').val(searchValues.type).trigger("change");
        $('.status-filter').val(searchValues.status).trigger("change");
        $('.funding-filter').val(searchValues.funding).trigger("change");

        $('.publication-filter').val(searchValues.publication).trigger("change");
        $('.term-filter').val(searchValues.topics).trigger("change");
        $('#term-field').val(searchValues.term);

      }



      var form = $('.ajax-search');

      if (stopLoad == undefined) {

        searchValues.getResults(form.attr('action'), form.serializeArray());
      }



    }

  };




  function setupFilters() {

    //$('.smart-search').html(opts)

    $('.smart-search').select2({
      placeholder: 'Search for a topic',
      dropdownPosition: 'below',
      tags: true,
      tokenSeparators: [','],
      minimumInputLength: 2,
      minimumResultsForSearch: 1,
      dropdownCssClass: 'mega-popup-drop',
      createTag: function (params) {
        var term = $.trim(params.term);

        if (term === '') {
          return null;
        }

        return {
          id: term,
          text: term,
          newTag: true // add additional parameters
        }
      }
    }).on('select2:unselect', function (e) {
      var data = e.params.data;
      console.log(data);

      if (data.newTag || searchValues.term == data.text) {
        searchValues.term = '';


      } else {
        searchValues.removeValue(data.element.getAttribute('data-group'), data.id);
      }

      searchValues.updateFilters();

    }).on('select2:select', function (e) {
      var data = e.params.data;
      console.log(data);


      if (data.newTag) {
        searchValues.term = data.text;
      } else {
        //console.log(data.element.getAttribute('data-group'));
        searchValues.addValue(data.element.getAttribute('data-group'), data.id);
      }



      searchValues.updateFilters();
    });




    $('.single-filter').select2().on('select2:select', function (e) {
      var data = e.params.data;
      console.log(data);

      if ($(e.target).hasClass('type-filter')) {

        searchValues.type = data.id;
      }

      if ($(e.target).hasClass('status-filter')) {

        searchValues.status = data.id;
      }

      if ($(e.target).hasClass('funding-filter')) {

        searchValues.funding = data.id;
      }

      if ($(e.target).hasClass('publication-filter')) {

        searchValues.publication = data.id;
      }

      //searchValues.push(data.id);

      $('.smart-search').val(searchValues.getValues()).trigger("change");



      searchValues.updateFilters();
    }).on('select2:unselect', function (e) {
      var data = e.params.data;
      console.log(data);


      if ($(e.target).hasClass('type-filter')) {

        searchValues.type = '';
      }

      if ($(e.target).hasClass('status-filter')) {

        searchValues.status = '';
      }

      if ($(e.target).hasClass('funding-filter')) {

        searchValues.funding = '';
      }
      if ($(e.target).hasClass('publication-filter')) {

        searchValues.publication = '';
      }

      searchValues.updateFilters();
    }).on('select2:close', function (e) {
      $('.open-filter.open').removeClass('open');

    });


    $('.order-search').on('change', function () {
      var form = $('.ajax-search');
      console.log('ffff');
      searchValues.getResults(form.attr('action'), form.serializeArray());

    });

    $('.multi-filter').select2({
      containerCssClass: 'topic-popup-container',
      dropdownCssClass: 'topic-popup-drop',
      dropdownPosition: 'below',
      closeOnSelect: false
    }).on('select2:select', function (e) {
      var data = e.params.data;
      console.log(data);

      searchValues.addTopic(data.id);

      // $('.smart-search').val(searchValues.getValues()).trigger("change");
      searchValues.updateFilters(true);


      console.log($('.smart-search').val(data.id));
    }).on('select2:unselect', function (e) {
      var data = e.params.data;
      console.log(data);



      searchValues.removeTopic(data.id);

      searchValues.updateFilters(true);
    }).on('select2:open', function (e) {
      console.log(e);
      if ($('.select2-dropdown .close-popup').length == 0) {
        $('.select2-dropdown').append('<button class="btn-primary close-popup ">Apply <svg class="icon arrow-right" aria-hidden="true" role="img"><use xlink:href="#arrow-right"></use></svg></button>');
      }

    }).on('select2:close', function (e) {
      setTimeout(function () {
        $('.open-filter').removeClass('open').css('pointer-events', 'all');

      }, 100);


    });
  }



  $('body').on('click', '.close-popup', function (e) {
    e.preventDefault();
    searchValues.updateFilters();
    $('.multi-filter').select2('close');

  });

  $('#search-results').on('click', '.clear-filter', function (e) {
    e.preventDefault();

    searchValues.clear();
  });
  $('#search-results').on('click', '.open-filter', function (e) {
    e.preventDefault();

    if ($(this).hasClass('open')) {

      // $(this).removeClass('open');
      //  $(this).next().select2('close');   

      console.log('close');
    } else {

      $(this).next().select2('open');
      $('.open-filter').removeClass('open').css('pointer-events', 'all');
      $(this).addClass('open').css('pointer-events', 'none');


      console.log('open');


    }

    $(this).blur();
  });

  $('#search-results').on('click', '.ajax-article-paging', function (e) {
    e.preventDefault();


    searchValues.getPageingList($(this).attr('href'));
  });

  setupFilters();


  searchValues.setup();

  if ($('.smart-search.auto-load').length > 0) {
    var form = $('.ajax-search');



    searchValues.getResults(form.attr('action'), form.serializeArray());


  }
})();



(function () {
  $('#article-results').on('click', '.open-filter', function (e) {
    e.preventDefault();
    $(this).addClass('open').css('pointer-events', 'none');
    $(this).next().select2('open');




  });

  $('#article-results').on('click', '.form-fill', function (e) {
    e.preventDefault();
    $('.form-fill').removeClass('selected');

    $(this).addClass('selected');
    $('#type-field').val($(this).data('value'));

    getPageList($('#article-results').find('form'));
  });

  $('#article-results2').on('click', '.form-fill', function (e) {
    e.preventDefault();
    $('.form-fill').removeClass('selected');

    $(this).addClass('selected');
    $('#type-field').val($(this).data('value'));

    getPageList($('#article-results2').find('form'));
  });

  $('#article-results2').on('click', '.ajax-article-paging', function (e) {
    e.preventDefault();


    getPageingList2($(this).attr('href'));
  });

  $('#article-results').on('click', '.ajax-article-paging', function (e) {
    e.preventDefault();


    getPageingList($(this).attr('href'));
  });

  $('#article-sticky-results').on('click', '.ajax-article-paging', function (e) {
    e.preventDefault();


    getPageingListSticky($(this).attr('href'));
  });

  function setup() {
    $('.order-search').on('change', function () {
      getPageList();
    });
    $('.article-search').select2({
      placeholder: 'Search for a topic',
      tags: true,
      dropdownPosition: 'below',
      tokenSeparators: [','],
      /*minimumInputLength:2,*/
      closeOnSelect: false,
      minimumResultsForSearch: 1,
      dropdownCssClass: 'mega-popup-drop mega-article-popup-drop',
      createTag: function (params) {
        var term = $.trim(params.term);

        if (term === '') {
          return null;
        }

        return {
          id: term,
          text: term,
          newTag: true // add additional parameters
        }
      }
    }).on('select2:unselect', function (e) {
      var data = e.params.data;
      console.log(e);

      var count = $(e.target).val().length;
      var lab = '';
      if (count > 0) {
        lab = '(' + count + ')';
      }
      $(e.target).prev().find('.count').html(lab);

    }).on('select2:select', function (e) {
      var data = e.params.data;
      console.log($(e.target).val());
      var count = $(e.target).val().length;
      var lab = '';
      if (count > 0) {
        lab = '(' + count + ')';
      }
      $(e.target).prev().find('.count').html(lab);

    }).on('select2:open', function (e) {
      console.log(e);
      if ($('.mega-article-popup-drop .close-article-popup').length == 0) {
        $('.mega-article-popup-drop').append('<button class="btn-primary close-article-popup ">Apply <svg class="icon arrow-right" aria-hidden="true" role="img"><use xlink:href="#arrow-right"></use></svg></button>');
      }

    }).on('select2:close', function (e) {
      $('.open-filter').removeClass('open').css('pointer-events', 'all');

    });

  }

  setup();
  $('body').on('click', '.close-article-popup', function (e) {
    e.preventDefault();
    getPageList()
    $('.article-search').select2('close');

  });
  function getPageList(form) {
    if (form == undefined) {
      form = $('.ajax-articles');

    }


    var fragmentId = '#article-results';
    var contentsFragmentId = '#article-results-contents';
    if (form.attr('data-id') !== undefined) {
      fragmentId = '#' + form.attr('data-id');
    }
    if (fragmentId=='#article-results2') {
      contentsFragmentId = '#article-results2-contents';
    }
    console.log(fragmentId);
    console.log(contentsFragmentId);
    var url = form.attr('action');

    var data = form.serializeArray();
    console.log(url);
    console.log(data);

    var container = $('<div class="loaded-data" style="visibility:visible;"></div>');

    if (data == undefined) {
      container.load(url + ' '+contentsFragmentId, function (e) {
        updatePage(fragmentId);
      });
  
    } else {
      container.load(url + ' '+contentsFragmentId, data, function (e) {
        updatePage(fragmentId);
      });
    }



    function updatePage(fragID) {
      console.log(fragID);
      if (fragID == undefined) {
        fragID = '#article-results';

      }
      container.find('.ajax-articles').addClass('reveal-complete revealed');


      if ($(fragID).length > 0) {
        $(fragID).empty().append(container);
      }


      if ($(fragID).length > 0) {
        // setupFilters();

        container.find('.hidden-child').not('.reveal-complete').each(function (i, el) {
          setTimeout(function () {

            $(el).addClass(' reveal-complete revealed');

          }, 80 * i);


        });


        var pos = $(fragID).offset().top;

        $('html,body').animate({
          scrollTop: pos
        }, 800);

        setup();
      }





    }

  }
  function getPageingList(url) {


    var container = $('<div class="loaded-data" style="visibility:visible;"></div>');


    container.load(url + ' #article-results-contents', function (e) {
      updatePageingPage();
    });

    function updatePageingPage() {
      if ($('#article-results').length > 0) {

        $('#article-results .page-count').html(container.find('.page-count').html());
        $('#article-results .filter-footer').html(container.find('.filter-footer').html());

        var newBlock = container.find('.article-grid-inner .item');
        $('#article-results .article-grid-inner').append(newBlock);
        // setupFilters();

        newBlock.not('.reveal-complete').each(function (i, el) {
          setTimeout(function () {

            $(el).addClass(' reveal-complete revealed');

          }, 80 * i);


        });


        var pos = newBlock.eq(0).offset().top;

        $('html,body').animate({
          scrollTop: pos
        }, 800);

        //);

      }




    }





  }
  function getPageingList2(url) {


    var container = $('<div class="loaded-data" style="visibility:visible;"></div>');


    container.load(url + ' #article-results-contents', function (e) {

      updatePageingPage3();
    });

    function updatePageingPage3() {
      if ($('#article-results2').length > 0) {

        $('#article-results2 .page-count').html(container.find('.page-count').html());
        $('#article-results2 .filter-footer').html(container.find('.filter-footer').html());

        var newBlock = container.find('.article-grid-inner .item');
        $('#article-results2 .article-grid-inner').append(newBlock);
        // setupFilters();

        newBlock.not('.reveal-complete').each(function (i, el) {
          setTimeout(function () {

            $(el).addClass(' reveal-complete revealed');

          }, 80 * i);


        });


        var pos = newBlock.eq(0).offset().top;

        $('html,body').animate({
          scrollTop: pos
        }, 800);

        //);

      }




    }





  }

  function getPageingListSticky(url) {


    var container = $('<div class="loaded-data" style="visibility:visible;"></div>');


    container.load(url + ' #article-results-sticky-contents', function (e) {
      updatePageingPageSticky();
    });

    function updatePageingPageSticky() {
      if ($('#article-sticky-results').length > 0) {

        $('#article-sticky-results .page-count').html(container.find('.page-count').html());
        $('#article-sticky-results .filter-footer').html(container.find('.filter-footer').html());

        var newBlock = container.find('.item');
        $('#article-results-sticky-contents-list').append(newBlock);
        // setupFilters();

        newBlock.not('.reveal-complete').each(function (i, el) {
          setTimeout(function () {

            $(el).addClass(' reveal-complete revealed');

          }, 80 * i);


        });


        var pos = newBlock.eq(0).offset().top;

        $('html,body').animate({
          scrollTop: pos
        }, 800);

        //);

      }




    }





  }
})();

(function () {

  $('.wp-block-video video').each(function (i, el) {
    if (el.hasAttribute("controls")) {
      el.setAttribute('data-controls', 'controls');
    }
    if (!el.hasAttribute("autoplay")) {
      $(el).parent().append('<div class="video-play"><svg class="icon play" aria-hidden="true" role="img"><use xlink:href="#play"></use></svg></div>');
    }
  });
  $('.wp-block-video video').removeAttr("controls").on('playing', function (e) {
    if (e.target.hasAttribute('data-controls')) {
      e.target.setAttribute("controls", "controls");
    }
    $(e.target).off('click');
  }).on('click', function (e) {
    e.target.play();
    e.target.parentNode.querySelector('.video-play').style.display = 'none';

  });


})();
var player;


(function () {

  if ($('.block-container > .anchor-menu').length > 0) {
      $('body').addClass('has-anchor-menu');
  }


  $('.anchor-menu').each(function (i, el) {
    var $nav = $(el);
    var $line = $nav.find('.line');

    $nav.find('a').on('mouseover click', function (e) {
      var text = $(this);
      var menuOffset = $nav.find('.menu').offset();
      $line.css({ 'left': text.offset().left - menuOffset.left, 'width': text.width() });
    }).on('mouseout', function (e) {
      resetLine($nav);
    });

    resetLine($nav);
  });



  function resetLine(menu) {
    if (menu.find('.active').length > 0) {
      var menuOffset = menu.find('.menu').offset();
      menu.find('.line').css({ 'left': menu.find('.active').offset().left - menuOffset.left, 'width': menu.find('.active').width() });
    } else {
      menu.find('.line').css({ 'left': 0, 'width': 0 });
    }
  }

})();


(function () {
  $('.related-modal--close').on('click', function (e) {
    e.preventDefault();
    var _body = document.querySelector('body');
    _body.classList.remove('related-modal--open');
  });
  $('.people-modal--close').on('click', function (e) {
    e.preventDefault();
    var _body = document.querySelector('body');
    _body.classList.remove('person-modal--open');
  });
  $('.proxy-person-modal').attr('aria-modal',true).attr('role','dialog').on('click', function (e) {
    e.preventDefault();

    var item = $($(this).attr('href'));

    $('.people-modal .people-modal--person').html(item.html());

    $('.people-modal .people-modal--box').html(item.find('.template').html());


    var _body = document.querySelector('body');
    _body.classList.toggle('person-modal--open');


  });
  
  $('body').on('click', '.person-popup', function (e) {
    e.preventDefault();
    if (this.hasAttribute("data-title")) {
      $('.people-modal--header h2').text(this.getAttribute('data-title'));
    } else {
      $('.people-modal--header h2').text('Profile');
    }
    var item = $(this).parents('.team-member');
    if (item.length == 0) {

      item = $(this).parents('.text-card');
    }
    if (item.find('.template-side').length > 0) {
      $('.people-modal--person').html(item.find('.template-side').html());
    } else {
      $('.people-modal--person').html(item.html());
    }


    $('.people-modal--box').html(item.find('.template').html());


    var _body = document.querySelector('body');
    _body.classList.toggle('person-modal--open');


  });


  $('.related-card a').attr('aria-modal',true).attr('role','dialog').on('click', function (e) {
    e.preventDefault();

    var item = $(this);
    //$('.related-modal--title').html(item.find('.post-item--heading').html());
    $('.related-modal--person').html(item.find('.popup-right').html());

    $('.related-modal--box').html(item.find('.popup-left').html());


    var _body = document.querySelector('body');
    _body.classList.toggle('related-modal--open');


  });


  function youTubeGetID(url) {
    var ID = '';
    url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_\-]/i);
      ID = ID[0];
    }
    else {
      ID = url;
    }
    return ID;
  }


  if ($('.video-popup').length > 0) {

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  }
  $('.video-modal--close').on('click', function (e) {
    e.preventDefault();
    player.stopVideo();
    var _body = document.querySelector('body');
    _body.classList.remove('video-modal--open');
  });
  $('.video-popup').attr('aria-modal',true).attr('role','dialog').on('click', function (e) {
    e.preventDefault();
    var url = $(this).attr('href');


    var id = youTubeGetID(url);
    console.log(id);
    var _body = document.querySelector('body');
    _body.classList.toggle('video-modal--open');

    if (!_body.classList.contains('video-modal--open')) {

      player.stopVideo();
    } else {

      if (player == undefined) {
        player = new YT.Player('modal-video', {
          videoId: id,
          playerVars: {
            autoplay: true,
            modestbranding: true,
            playsinline: true,
            color: 'white',
            rel: 0
          }

        });


      } else {
        player.loadVideoById(id);
      }

    }
  });


})();


(function () {
  $('.is-style-expand').each(function (i, el) {
    var img = $(this).find('img');

    var srcs = img.attr('data-srcset');

    src = srcs.split(', ')[0];
    ;
    $(this).find(' > *').wrap('<a href="' + src.split(' ')[0] + '"></a>');
    $(this).find('a').append('<div class="icon-box"><svg class="icon zoom-in" aria-hidden="true" role="img"><use xlink:href="#zoom-in"></use></svg></div>');

  });

  $('.is-style-expand a').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: true,
    fixedContentPos: true,
    mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
    image: {
      verticalFit: true
    },
    zoom: {
      enabled: true,
      duration: 450 // don't foget to change the duration also in CSS
    }
  });

})();

(function () {

  $('.rte iframe').each(function (i, el) {



    if (!$(el).parent().hasClass('fluid') && $(el).attr('src').includes('youtube')) {

      $(el).wrap('<div class="fluid"></div>');

    }

  });

  $('.text-card .small-heading').succinct({
    size: 120
  });

})();


var anno;
(function () {


  var intros = [

    {
      test: '.home .action-buttons',
      slug: 'tip__home',
      list: {
        target: '.home .search-btn',
        content: 'We’ve improved search to make it easier to find what you’re looking for.',
        position: 'left',
        buttons: [
          {
            text: '<svg class="icon close" role="img"><use xlink:href="#close"></use></svg>',
            className: 'anno-btn-low-importance',
            click: function (anno, evt) {
              anno.hide()
            }
          }
        ]
      },
    },
    {
      test: '.main-search-form',
      slug: 'tip__search',
      list: {
        target: '.main-search-form',
        content: 'Manage your filters and tags in the search bar.',
        position: 'center-bottom',
        buttons: [
          {
            text: '<svg class="icon close" role="img"><use xlink:href="#close"></use></svg>',
            className: 'anno-btn-low-importance',
            click: function (anno, evt) {
              anno.hide()
            }
          }
        ]
      },


    },
    {
      test: '.hero .tag-list',
      slug: 'tip__tags',
      list: [{
        target: '.hero .tag-list a:first',
        content: 'These tags will help you find similar content.',
        position: 'top',
        buttons: [
          {
            text: '<svg class="icon close" role="img"><use xlink:href="#close"></use></svg>',
            className: 'anno-btn-low-importance',
            click: function (anno, evt) {
              anno.hide()
            }

          }
        ]
      },
      ]
    },
    {
      test: '.search-block .overlay-form',
      list: {
        target: '.search-block .overlay-form',
        content: 'See a full list of relevant content within this topic.',
        position: 'center-top',
        buttons: [
          {
            text: '<svg class="icon close" role="img"><use xlink:href="#close"></use></svg>',
            className: 'anno-btn-low-importance',
            click: function (anno, evt) {
              anno.hide()
            }
          }
        ]
      }

    }

  ];
  //if ($('.site-banner').length>0 && $.cookie($('.site-banner').attr('data-slug')) == undefined) {


  //  } else {

  /* if ($('body').width()>767) {

       setTimeout(function() {
           for (var i=0; i<intros.length; i++) {
                 var item = intros[i];
                 console.log($.cookie(item.slug));   
                 if ($(item.test).length>0 && $.cookie(item.slug) == undefined) {
                    anno = new Anno(item.list);
                    anno.show();
                    $.cookie(item.slug,'viewed');
                 }


             }

       },1500);

   } */
  // }


})();





(function () {


  // check for hash 

  if (window.location.hash) {
    var hsh = window.location.hash;

    hsh = hsh.replace('!', '');
    if ($(hsh).length > 0) {
      //scroll(0, 0);
      // void some browsers issue
      //setTimeout(scroll(0, 0), 1);
      setTimeout(function () {
        scrollToLink($(hsh), hsh, false);
      }, 500);

    }
  }


  function scrollToLink(target, hash, animate) {

    console.log(target);
    if (target.length > 0) {

      console.log(target);


      //Tab switcher
      if (target.hasClass('accordion-item')) {
        if (target.parents('.tab-block').length > 0) {

          var tab = target.parents('.tab-block');

          console.log(tab);
          var tempHash = '#' + tab.attr('id');
          var _parent = tab.parents('.tabs-block');
          _parent.find('.anchor-menu a').removeClass('active');
          _parent.find('.anchor-menu a[href=' + tempHash + ']').trigger('click');



        }

        target.removeClass('closed');




        target.find('.accordion-panel').slideDown();

      }
      // if (hash.includes('gf_') && target.hasClass('tab-block')) {


      // }


      if (target.hasClass('tab-block')) {

        var tab = target;
        var temp = tab.parents('.sticky-article');

        if (temp.length > 0) {
          //console.log('tab-block');
          target = temp;
          var _parent = tab.parents('.tabs-block');
          _parent.find('.anchor-menu a').removeClass('active').attr('aria-expanded','false');

          _parent.find('.anchor-menu a[href=' + hash + ']').trigger('click');

          //tab.addClass('active');
        }

        var temp2 = tab.parents('.tabbed-accordion');

        if (temp2.length > 0) {
          console.log('tab-block');
          target = temp2;
          var _parent = tab.parents('.tabs-block');
          _parent.find('.anchor-menu a').removeClass('active').attr('aria-expanded','false')

          _parent.find('.anchor-menu a[href=' + hash + ']').trigger('click');

          //tab.addClass('active');
        }



      }

      var pos = target.offset().top - 100;


      var container = $(this).closest('.mobile-dropdown');
      console.log(container);
      if (container.length > 0) {
        container.removeClass('open');
      }



      if (hash == '#top') {
        pos = 0;
      }





      //if (animate) {
      $('html,body').animate({
        scrollTop: pos
      }, 800);
      // }


    }

  }

  $('.custom-password-message').each(function(e) {
    var target = $(this).parents('.article-area');
    if (target.length) {
      
      var pos = target.offset().top - 100;
      
      $('html,body').animate({
        scrollTop: pos
      }, 800);

    }
  });
  $('a.modal').attr('aria-modal',true).attr('role','dialog');
  console.log($('a[href*="#"]:not([href="#"])').not('.scroll-to').not('.js-link').not('.button-modal').not('.button-close'));
  $('a[href*="#"]:not([href="#"])').not('.scroll-to').not('.js-link').not('.button-modal').not('.button-close').not('.reference-link').on('click', function (e) {
    console.log('an');
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      console.log('an t');
      if (target.length && !target.hasClass('modal')) {

        console.log('an go');
        e.preventDefault();
        if ($(this).parents('.accordion-item').length>0) {
          $(this).parents('.accordion-item').addClass('closed');

          $(this).parents('.accordion-panel').hide();
        }
        scrollToLink(target, this.hash, true);
        setTimeout(function () {
          $(this).trigger("blur");
          target.trigger('focus');
        }, 100);
        return false;
      } else if (target.length && target.hasClass('modal')) {
        e.preventDefault();
        

        

        $('body').addClass('has-modal-open');
        $(target).show();
        
        
      }
    }
  });

  $('.modal .modal--close').on('click',function() {
    $(this).parents('.modal').hide();

    $('body').removeClass('has-modal-open');
  });
  $('.modal .modal-proxy').on('click',function() {
   
    $(this).parents('.modal').hide();
    
    $('body').removeClass('has-modal-open');
  });
})();



(function () {
  var notifyCounter;

  if ($('.notification-bar').length > 0) {
    addNotification($('.notification-bar').html());
  }


  function addNotification(html) {
    if (notifyCounter !== undefined) {
      clearTimeout(notifyCounter);

    }
    $('.notification-bar').remove();

    $('body').append('<div class="notification-bar">' + html + '</div>');

    setTimeout(function () {
      $('.notification-bar').addClass('show');
    }, 25);


    notifyCounter = setTimeout(function () {
      $('.notification-bar').remove();
      notifyCounter = undefined;
    }, 3500);


  }


  function getSavedSearch(key) {
    for (var i = 0; i < searchHistory.saved.length; i++) {
      console.log(key + '  ' + searchHistory.saved[i].search);
      if (key == searchHistory.saved[i].search) {
        return searchHistory.saved[i];
      }
    }
    return false;
  }
  function clickOutside(e) {
    if ($(e.target).closest(".save-popup").length === 0) {
      hideFavBox();
      //$('.open-popup').removeClass('open-popup');
      //$(".save-popup").hide();
      //$('.popout-box').remove();

      //$(document).off('click',clickOutside);
    }
  }


  $('body').on('click', '.delete-item', function (e) {
    e.preventDefault();
    var item = $(this).parents('.saved-item');

    item.css('opacity', 0.3);
    $.post("/prodapi/unfav_search/", { id: $(this).attr('data-item') }).done(function (e) {

      item.slideUp();


      addNotification('Saved favourite deleted');
    });

  });


  $('body').on('input', '.saved-title', function (e) {
    $('.set-search-title').show();


  });



  $('body').on('keypress', '.saved-title', function (e) {
    if (e.which === 13) {

      var item = $(this).parents('.saved-item');

      if (item.length > 0) {

        item.find('.saved-item--heading').text($(this).val());
      }
      console.log($(this).val());

      $.post("/prodapi/fav_search/", { id: $(this).parent().find('.set-search-title').attr('data-item'), title: $(this).val() }).done(function (e) {

        $('.set-search-title').hide();

        $('.saved-item--heading').show();
        $('.saved-item').find('.form-row').hide();
        addNotification('Name changed');
      });
    }
  });

  $('body').on('click', '.edit-item', function (e) {
    e.preventDefault();
    var item = $(this).parents('.saved-item');
    item.find('.saved-item--heading').hide();
    item.find('.form-row').show();
    item.find('.set-search-title').show();


  });


  $('body').on('click', '.cancel-search-title', function (e) {
    $('.set-search-title').hide();
    $('.saved-item--heading').show();
    $('.saved-item').find('.form-row').hide();


  });

  $('body').on('click', '.set-search-title', function (e) {
    e.preventDefault();
    var btn = $(this);
    var item = $(this).parents('.saved-item');
    console.log(item);
    if (item.length > 0) {

      item.find('.saved-item--heading').text($(this).parents('.form-row').find('.saved-title').val());
    }


    $.post("/prodapi/fav_search/", { id: btn.attr('data-item'), title: $(this).parents('.form-row').find('.saved-title').val() }).done(function (e) {

      $('.set-search-title').hide();

      $('.saved-item--heading').show();
      $('.saved-item').find('.form-row').hide();
      addNotification('Name changed');
    });
  });

  $('body').on('change', '.save-alert', function (e) {
    console.log(e.target.checked);
    var alertValue = 0;
    if (e.target.checked) {
      alertValue = 1;

      addNotification('Email alert enabled');
    } else {
      addNotification('Email alert disabled');

    }
    var id;
    if ($(this).attr('data-item') !== undefined) {

      id = $(this).attr('data-item');
    } else {
      id = $(this).parents('.save-box').find('.btn-save').attr('data-item');
    }


    console.log('id ' + id);

    $.post("/prodapi/fav_search/", { id: id, alert: alertValue }).done(function (e) {

      //$('.set-search-title').attr('data-item',e);

    });


  });

  var initialQuery = $('.ajax-search').serialize();

  if (initialQuery !== undefined) {
    var brokenparts = initialQuery.split('&status=');
    initialQuery = brokenparts[0];
    brokenparts = initialQuery.split('&order=');
    initialQuery = brokenparts[0];

    if (searchHistory !== undefined) {

      savedValue = getSavedSearch(initialQuery);
      if (savedValue) {
        $('.btn-save.is-search-btn').addClass('saved').attr('data-item', savedValue.id);
      }
    }


  }

  function showFavBox($item, $button) {

    $('.popout-box').remove();
    var pos = $button.offset();
    $('body').removeClass('headroom-page--pinned').addClass('save-box-open');
    console.log('show pop');
    console.log($item.html());
    var newBox = $($item.html());
    $('.block-container').append(newBox);
    newBox.find('.save-alert').attr('data-item', $button.attr('data-item'));
    newBox.find('.set-search-title').attr('data-item', $button.attr('data-item'));



    newBox.addClass('popout-box').show();

    //.css({position:'absolute',top:pos.top,left:left,display:'block'});
    setTimeout(function () {
      $(document).on('click', clickOutside);
    }, 150);
    return newBox;
  }

  function hideFavBox() {
    $('body').removeClass('save-box-open');
    $('.popout-box').remove();
    $(document).off('click', clickOutside);

  }

  $('body').on('click', '.save-popup .popup--close', function (e) {
    e.preventDefault();
    // $item = $(this);
    hideFavBox();
  });
  $('body').on('click', '.btn-save', function (e) {


    e.preventDefault();
    $item = $(this);
    console.log($item);

    console.log($item.hasClass('not-logged-in'));
    $(document).off('click', clickOutside);
    if ($item.hasClass('not-logged-in')) {
      console.log('not logged in');

      $('.open-popup').removeClass('open-popup');

      showFavBox($item.parent().find('.save-box-template'), $item);

      // $item.parent().find('.save-popup').show();

      //$item.parents('.card-item').addClass('open-popup');
    } else if ($item.hasClass('saved')) {
      //$('.open-popup').removeClass('open-popup');

      hideFavBox();
      //$item.parent().find('.save-popup').hide();
      //$item.parents('.card-item').removeClass('open-popup');

      if ($item.attr('data-item') !== undefined) {
        $item.removeClass('saved');
        addNotification('Removed from favourites');
        console.log($item);
        if ($item.hasClass('is-search-btn')) {

          $.post("/prodapi/unfav_search/", { id: $item.attr('data-item') }).done(function (e) {
            $item.removeAttr('data-item');
            console.log(e);
          });


        } else {
          $.post("/prodapi/unfav_project/", { id: $item.attr('data-item') }).done(function (e) {
            $item.removeAttr('data-item');
            console.log(e);
          });
        }

      }


    } else {
      console.log('save');
      $item.addClass('saved');


      if ($item.hasClass('is-search-btn')) {

        var saveQuery = $('.ajax-search').serialize()

        var brokenparts = saveQuery.split('&status=');
        saveQuery = brokenparts[0];
        brokenparts = saveQuery.split('&order=');
        saveQuery = brokenparts[0];
        $('.open-popup').removeClass('open-popup');

        $.post("/prodapi/fav_search/", { st: saveQuery }).done(function (e) {
          $item.attr('data-item', e);

          addNotification('Added to favourites');
          showFavBox($item.parent().find('.save-box-template'), $item);
          /* $item.parent().find('.save-popup').show();
           setTimeout(function(){
             $(document).on('click',clickOutside);
           },150);*/
          // $item.parents('.card-item').addClass('open-popup');
        });
      } else {
        $('.open-popup').removeClass('open-popup');
        $('.save-popup').hide();
        $.post("/prodapi/fav_project/", { p: $item.attr('data-id') }).done(function (e) {
          $item.attr('data-item', e);
          addNotification('Added to favourites');


          showFavBox($item.parent().find('.save-box-template'), $item);
          //$item.parent().find('.save-popup').show(); 
          /*setTimeout(function(){
            $(document).on('click',clickOutside);
          },150);
          $item.parents('.card-item').addClass('open-popup');*/
        });

      }


    }

  });

})();
(function () {
  var players = [];

  $('.audio-controller').each(function (i, el) {
    var item = $(el).parents('.audio-item');


    var p = new Plyr(el, {
      loadSprite: false,
      controls: [

        'play', // Play/pause playback

        'progress', // The progress bar and scrubber for playback and buffering
        'current-time', // The current time of playback
        'duration', // The full duration of the media
      ]

    });
    item.find('.audio-item__icon').on('click', function () {

      p.togglePlay();

    });
    p.on('playing', function (event) {
      item.addClass('active');

      for (var i = 0; i < players.length; i++) {
        if (p == players[i]) {

        } else {
          if (players[i].playing) {
            players[i].pause();

          }

        }
      }
    });
    p.on('ended', function (event) {
      item.removeClass('active');

    });
    p.on('pause', function (event) {
      item.removeClass('active');
    });

    players.push(p);


  });


  //Plyr.setup(document.querySelectorAll('.audio-controller'))

})();


(function () {
  $('.mobile-show-more').each(function (i, el) {
    var $container = $(el);
    var total = $container.attr('data-show');
    var items = $container.find('.item');

    if ($container.hasClass('desktop-show-more') && $('body').width() > 600) {
      total = $container.attr('data-desktop-show');
    }

    if (items.length > total) {

      items = $container.find('.item').slice(0, total);
      items.addClass('show');

      $container.find('.item').not('.show').removeClass('reveal-complete revealed')

      $container.append('<div style="width:100%;"><button style="width:100%; margin-top:20px;" class="show-more-cta btn-primary" >Load more</a></div>');

      $container.find('.show-more-cta').on('click', function () {

        items = $container.find('.item').not('.show').slice(0, total);

        items.addClass('show');
        items.each(function (k, it) {
          var $it = $(it);
          setTimeout(function () {
            $it.addClass('reveal-complete revealed')
          }, (75 * k) + 25);


        });

        if ($container.find('.item').not('.show').length == 0) {
          $container.find('.show-more-cta').remove();
        }
      });
    } else {

      items = $container.find('.item');
      items.addClass('show');
      items.each(function (k, it) {
        var $it = $(it);
        setTimeout(function () {
          $it.addClass('reveal-complete revealed')
        }, (75 * k) + 25);


      });
    }


  });
})();


(function () {
  $('a[href$=".pdf"]').attr('target', '_blank');
  $('a[href$=".doc"]').attr('target', '_blank');
  $('a[href$=".docx"]').attr('target', '_blank');

  if ($('.site-banner').length > 0 && $.cookie($('.site-banner').attr('data-slug')) == undefined) {



    $('.site-banner').addClass('show');

    $('.site-banner--close').on('click', function (e) {
      e.preventDefault();

      $.cookie($('.site-banner').attr('data-slug'), 'viewed', { expires: parseInt($('.site-banner').attr('data-length')) });
      console.log('close');
      $('.site-banner').remove();

    });
  }






})();


(function(){
 
  $('body').on('click','.view-switch',function(e) {

    e.preventDefault();
    $('.view-switcher button').removeClass('active');

    $(this).addClass('active');
    

    if ($(this).attr('data-view')=='single-view') {
      $('.article-grid .article-grid-inner').addClass('single-view');
    } else {
      $('.article-grid .article-grid-inner').removeClass('single-view');
    }


  });


  $('body').on('click','.show-more-tags',function(e) {

    $(this).hide();
    $(this).parent().find('.more-tags').css('display','inline-block');

  });
  var postID = $('body').attr('data-id');
  if (postID!==undefined) {
    setTimeout(function() {

      $.post("/prodapi/set_popular/", { id: postID }).done(function (e) {

        console.log(e);
      });

    },6500);   

  }
  
})();


(function(){

  $('.tagged-items-group').each(function(v,group){
  var taggedItems = $(group).find('.tagged-item');

  if (taggedItems.length) {
    var tagMenu = '';
    var uniqueTags = [];
    taggedItems.each(function(i,el) {

      var tag = el.getAttribute('data-tag');
      if (!uniqueTags.includes(tag) && tag.length>0) {
        uniqueTags.push(tag);
        tagMenu+= '<li><a class="js-link tag-filter" data-tag="'+tag+'"  href="#">'+tag+'</a></li>';
      }
    });


    if (tagMenu.length>0) {
      $(group).find('.sub-block--content').prepend('<nav class="menu menu-horizontal menu-tags "><ul><li><a class="js-link tag-filter selected" data-tag=""  href="#">All</a></li>'+tagMenu+'</ul></nav>');
    }
    var menuItems = $(group).find('.tag-filter');
    menuItems.on('click',function(e) {
      e.preventDefault();
      menuItems.removeClass('selected');
      e.target.classList.add('selected');
      var value = e.target.getAttribute('data-tag');  
      taggedItems.each(function(k,element) {
        if (value === "") {
          element.classList.remove("hidden");
        } else {
          var tag = element.getAttribute('data-tag');
          if (!tag || tag !== value) {
            element.classList.add("hidden");
          } else {
            element.classList.remove("hidden");
          }
        }
      });
    });

  }
});
})()

app.init();

// references
function processReferences() {
	if (document.querySelector(".contains-ref-shortcode") !== null) {
		const contentElement = document.querySelector(".contains-ref-shortcode");
		let content = contentElement.innerHTML;

		const refRegex = /\[ref\](.*?)\[\/.*?ref\]/g;
		let matches = [];
		let match;
		let refCounter = 1;
		while ((match = refRegex.exec(content)) !== null) {
			matches.push({
				refHTML: match[1],
				originalPositionId: `ref-original-${refCounter++}`,
			});
		}

		if (matches.length > 0) {
			// console.log("Found references:", matches);

			let referencesContainer = document.createElement("div");
			referencesContainer.id = "references";
			referencesContainer.className ="page-references";

			let referencesTitle = document.createElement("h2");
			referencesTitle.innerText = "References";
			referencesTitle.className = "page-references-heading";

			let referencesList = document.createElement("ol");
			referencesList.id = "referencesList";
			referencesList.className = "page-references-list";

			referencesContainer.appendChild(referencesTitle);
			referencesContainer.appendChild(referencesList);

			const pageFooterMetaElement = document.querySelector("#pageFooterMeta");
			pageFooterMetaElement.prepend(referencesContainer);

			let refCounter = 1;

			content = content.replace(refRegex, function () {
				let originalPositionId = `ref-original-${refCounter}`;
				let anchorMarkup = `<a class="reference-link reference-link--numbered" id="${originalPositionId}" href="#reference-${refCounter}"><sup>[${refCounter++}]</sup></a>`;
				return anchorMarkup;
			});

			let backLInkArrow = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.19983 12.4655L8.19983 5.32522L10.7194 7.84493L11.7 6.86577L7.49995 2.66553L3.29995 6.86577L4.27978 7.84566L6.80007 5.32522L6.80007 12.4655L8.19983 12.4655Z" fill="currentColor"/></svg>`;

			matches.forEach(({ refHTML, originalPositionId }, index) => {
				let listItem = document.createElement("li");
				listItem.innerHTML = refHTML;
				listItem.id = `reference-${index + 1}`;

				let backLink = document.createElement("a");
				backLink.href = `#${originalPositionId}`;
				backLink.className = "reference-link reference-link--back";
				backLink.innerHTML = backLInkArrow + " <span>Back</span>";
				listItem.appendChild(backLink);

				referencesList.appendChild(listItem);
			});

			contentElement.innerHTML = content;
		}
	}
}

document.addEventListener("DOMContentLoaded", processReferences());